import {
    USER_DROPDOWN_BY_COMPANY_N_ROLE,
    USER_LIST,
    USER_PAGINATION,
    CLEAR_USER_LIST
} from "./constant";

export const initStateFeed = {
    usersList: [],
    usersPagination: {},
    userDropdownList: [],
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case USER_LIST: {
            return { ...state, usersList: action.payload };
        }
        case USER_PAGINATION: {
            return { ...state, usersPagination: action.payload };
        }
        case USER_DROPDOWN_BY_COMPANY_N_ROLE: {
            return {
                ...state,
                userDropdownList: action.payload,
            };
        }
        case CLEAR_USER_LIST: {
            return {
                ...state,
                usersList: [],
                usersPagination: {},
            };
        }
        default:
            return state;
    }
};
